module.exports = __webpack_public_path__ + "static/media/braintree_icon.c8d5123b.svg";